export class DeviceUpdateStatus {
    id: string;
    type: string;
    state: number;
    notification_method: number;
    utc_timestamp: string;
    additional_data: string;
    correlation_id: string;
    attempts: number | null;

    constructor(id: string, type: string, state: number, notification_method: number, utc_timestamp: string, additional_data: string, correlation_id: string, attempts: number | null) {
        this.id = id;
        this.type = type;
        this.state = state;
        this.notification_method = notification_method;
        this.utc_timestamp = utc_timestamp;
        this.additional_data = additional_data;
        this.correlation_id = correlation_id;
        this.attempts = attempts;
    }
}

export class UpdateStatus {
    id: number;
    name: string;
    constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }
}

interface IUpdatesAPI {
    getDevicesUpdateInfo(queryParams?: string, pageNum?: number, countPerPage?: number): Promise<DeviceUpdateStatus[]>;
    getUpdateStatusList(): Promise<UpdateStatus[]>;
    getDetailedUpdateList(deviceId: string, deviceType: string): Promise<DeviceUpdateStatus[]>;
    getUpdateCount(queryParams?: string): Promise<number>;
}

export default IUpdatesAPI;